import { useEffect } from 'react';
import { useSession } from '../auth';
import { navigate } from './router';

/**
 * Client-side auth gate for /me and /result surfaces: once the session check
 * settles anonymous, bounce through /auth with the current path as returnTo.
 * API 401s remain the authoritative backstop — pages still handle them.
 */
export function useRequireAuth(path: string): 'loading' | 'authenticated' | 'anonymous' {
  const { status } = useSession();
  useEffect(() => {
    if (!import.meta.env.DEV && status === 'anonymous') {
      navigate(`/auth?returnTo=${encodeURIComponent(path)}`, { replace: true });
    }
  }, [status, path]);
  return import.meta.env.DEV ? 'authenticated' : status;
}
